var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        top: "5vh",
        width: "80%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-tabs",
        {
          staticClass: "new_ticket_tabs",
          staticStyle: { "border-bottom": "1px solid #DCDFE6", width: "100%" },
          attrs: { slot: "title", type: "card" },
          on: { "tab-click": _vm.onTabClick },
          slot: "title",
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "新建普通工单" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "新建模板工单" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "新建普通工单(新版)" } })
        ],
        1
      ),
      _vm._v(" "),
      0 == _vm.activeTab
        ? _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticStyle: { width: "75%" },
                  attrs: {
                    model: _vm.ticketNew,
                    rules: _vm.rules,
                    "label-width": "80px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-right": "40px" },
                      attrs: { label: "标题", prop: "orderTitle" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: "",
                          placeholder: "工单标题",
                          clearable: ""
                        },
                        model: {
                          value: _vm.ticketNew.orderTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.ticketNew, "orderTitle", $$v)
                          },
                          expression: "ticketNew.orderTitle"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "类型", prop: "orderType" } },
                            [
                              _c("TicketTypeCascader", {
                                attrs: { css: "width:100%" },
                                model: {
                                  value: _vm.ticketNew.orderType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ticketNew, "orderType", $$v)
                                  },
                                  expression: "ticketNew.orderType"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "优先级", prop: "orderPriority" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value: _vm.ticketNew.orderPriority,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ticketNew,
                                        "orderPriority",
                                        $$v
                                      )
                                    },
                                    expression: "ticketNew.orderPriority"
                                  }
                                },
                                _vm._l(_vm.orderPriorityList, function(ll) {
                                  return _c("el-option", {
                                    key: ll.id,
                                    attrs: { label: ll.name, value: ll.id }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        width: "100%",
                        "padding-right": "40px",
                        "padding-bottom": "10px"
                      },
                      attrs: { label: "内容", prop: "orderContent" }
                    },
                    [
                      _c("EditorSummernote", { ref: "summernote_2" }),
                      _vm._v(" "),
                      _c("TicketUploadList", {
                        ref: "upList",
                        attrs: { ticketUpload: _vm.$refs.up2 }
                      }),
                      _vm._v(" "),
                      _c("TicketTemplateSelect", {
                        on: { selected: _vm.onTicketTemplateSelected }
                      }),
                      _vm._v(" "),
                      _c("TicketUpload", {
                        ref: "up2",
                        attrs: { ticketUploadList: _vm.$refs.upList }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系人",
                                prop: "contactUserName"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入联系人",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.ticketNew.contactUserName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ticketNew,
                                      "contactUserName",
                                      $$v
                                    )
                                  },
                                  expression: "ticketNew.contactUserName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系电话",
                                prop: "contactUserPhone"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入联系电话",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.ticketNew.contactUserPhone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ticketNew,
                                      "contactUserPhone",
                                      $$v
                                    )
                                  },
                                  expression: "ticketNew.contactUserPhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "处理人", prop: "assignUserId" }
                            },
                            [
                              _c("DealUserSearch", {
                                ref: "assignUser",
                                attrs: { css: "width:100%" },
                                on: { change: _vm.updateAssignUserId }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "关联商家", prop: "merchantId" }
                            },
                            [
                              _c("MerchantSearch", {
                                ref: "merchantId",
                                attrs: { css: "width:100%" },
                                on: { change: _vm.updateMerchantId }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "抄送人" } },
                            [
                              _c("NoticeUserSearch", {
                                attrs: {
                                  css: "width: 100%;",
                                  id: _vm.ticketNew.orderNoticeList
                                },
                                on: { change: _vm.updateMessageGroupId }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "关联订单",
                                prop: "merchantOrderId"
                              }
                            },
                            [
                              _c("MerchantOrderSearch", {
                                ref: "merchantOrderId",
                                attrs: { css: "width: 100%;" },
                                on: { change: _vm.updateMerchantOrderId }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "关联项目" } },
                            [
                              _c("TicketProjectSelect", {
                                ref: "ticketProjectSelect",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.ticketNew.projectIdArray,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ticketNew,
                                      "projectIdArray",
                                      $$v
                                    )
                                  },
                                  expression: "ticketNew.projectIdArray"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "标签" } },
                            [
                              _c("TicketTag", {
                                ref: "ticketTag",
                                attrs: { pmode: "detail" },
                                model: {
                                  value: _vm.ticketNew.ticketTagArray,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ticketNew,
                                      "ticketTagArray",
                                      $$v
                                    )
                                  },
                                  expression: "ticketNew.ticketTagArray"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("NewTicketRelated", {
                attrs: { orderTitle: _vm.ticketNew.orderTitle }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      1 == _vm.activeTab
        ? _c(
            "div",
            { staticStyle: { "min-height": "45vh", "padding-left": "20px" } },
            _vm._l(_vm.ticketTemplateList, function(e) {
              return _c(
                "a",
                {
                  key: e.id,
                  staticClass: "el-button",
                  staticStyle: {
                    margin: "10px",
                    "font-size": "18px",
                    padding: "5px 10px!important",
                    height: "45px!important"
                  },
                  attrs: {
                    title: "点击打开新建工单页面 创建 " + e.name,
                    href: "/ticket-vue/new-ticket?templateId=" + e.id
                  }
                },
                [_vm._v(_vm._s(e.name))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      2 == _vm.activeTab
        ? _c("div", { staticClass: "new-ticket-tab-content" }, [
            _vm._v("\n    新建普通工单 正在\n    "),
            _c("a", { attrs: { href: "/ticket-vue/new-ticket?136" } }, [
              _vm._v("跳转")
            ]),
            _vm._v("\n    到新建页面\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          0 == _vm.activeTab
            ? _c("SubmitTicketButton", {
                ref: "submitBtn",
                on: { click: _vm.insertTicket }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63f319a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f319a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/NewTicketDialog.vue
// module id = 776
// module chunks = 75